export enum TerminalActionType {
  auth = '[Terminal] Auth',
  choose = '[Terminal] Choose Task',
  unchoose = '[Terminal] Unchoose Task',
  finalizeTask = '[Terminal] Finalize Task',
  load = '[Terminal] Load',
  loadAll = '[Terminal] Loading all tasks',
  finalize = '[Terminal] Finalize',
}
